module.exports = __webpack_public_path__ + "img/LF005-05.679adced.jpg";